"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var cs_fleet_const_1 = require("./cs-fleet.const");
/**
 * CSFleetService
 * @class
 */
var CSFleetService = /** @class */ (function () {
    function CSFleetService() {
    }
    /**
     * Returns a vehicle details for a given `vehicleUuid`
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns Vehicle
     */
    CSFleetService.prototype.getVehicleDetails = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v2'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getVehicleDetails
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicles GPS location for a given `vehicleUuid`
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns any
     */
    CSFleetService.prototype.getGpsPosition = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getGpsPosition
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to immobilized for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns any
     */
    CSFleetService.prototype.getImmobilize = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getImmobilize
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to mobilized for a given uuid
     * @param vehicleUuid {string}
     * @returns any
     */
    CSFleetService.prototype.getMobilize = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getMobilize
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to open doors for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns {}
     */
    CSFleetService.prototype.getOpenDoors = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getOpenDoors
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to closed doors for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns {}
     */
    CSFleetService.prototype.getCloseDoors = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getCloseDoors
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to open (using admin privileges) for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns {}
     */
    CSFleetService.prototype.getOpenAsAdmin = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getOpenAsAdmin
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates vehicle status to open (using admin privileges) for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns {}
     */
    CSFleetService.prototype.getCloseAsAdmin = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getCloseAsAdmin
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves a vehicle description for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns any
     */
    CSFleetService.prototype.getDescriptions = function (vehicle, version) {
        if (version === void 0) { version = 'v2'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getDescriptions
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicle);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves a list of vehicle's equipments  for a given uuid
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns {}
     */
    CSFleetService.prototype.getEquipments = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getEquipments
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Applies a patch to an equipments list of the vehicle
     * @param version {string}
     * @param vehicleUuid {string}
     * @param data {Partial(Equipment[])} object of an equipments list
     * @returns Equipment[]
     */
    CSFleetService.prototype.putEquipments = function (vehicleUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.putEquipments
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Applies a patch to vehicle details
     * @param version {string}
     * @param vehicleUuid {string}
     * @param data {Partial(Vehicle)} partial object of vehicle details
     * @returns any
     */
    CSFleetService.prototype.patchVehicleDetails = function (vehicleUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.patchVehicleDetails
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, data);
    };
    /**
     * Retrieves a list of comments
     * @param vehicleUuid {string}
     * @returns `Comment[]`
     */
    CSFleetService.prototype.getComments = function (vehicleUuid) {
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getComments.replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Creates a new comment
     * @param data `NewComment`
     * @returns `Comment`
     */
    CSFleetService.prototype.postComment = function (data) {
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.postComment;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Edit an existing comment by `id`
     * @param vehicleUuid {string}
     * @param data `Comment`
     * @returns `Comment`
     */
    CSFleetService.prototype.putComment = function (vehicleUuid, data) {
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.putComment.replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes a comment by `id`
     * @param vehicleUuid {string}
     */
    CSFleetService.prototype.deleteComment = function (vehicleUuid) {
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.deleteComment.replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Returns a list of vehicle damages for a given `vehicleUuid`
     * @param version {string}
     * @param vehicleUuid {string}
     * @returns Damages
     */
    CSFleetService.prototype.getDamages = function (vehicleUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = cs_fleet_const_1.CS_FLEET_ENDPOINT.getDamages
            .replace('{{version}}', version)
            .replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return CSFleetService;
}());
/**
 * CSFleetService Class Instance
 * @namespace
 */
exports.csfleet = new CSFleetService();
